"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformScreenVersionToJSON = exports.transformJSONToScreenVersion = void 0;

require("core-js/modules/es.array.map.js");

var _asset = require("./asset");

var _colorData = require("./color-data");

var _grid = require("./grid");

var _layer = require("./layer");

var _link = require("./link");

var _sourceEnum = require("./source-enum");

var _thumbnails = require("./thumbnails");

var _user = require("./user");

var _versionCommit = require("./version-commit");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformScreenVersionToJSON = function transformScreenVersionToJSON(value) {
  return {
    id: value.id,
    creator: value.creator && (0, _user.transformUserToJSON)(value.creator),
    commit: value.commit && (0, _versionCommit.transformVersionCommitToJSON)(value.commit),
    image_url: value.imageUrl,
    thumbnails: value.thumbnails && (0, _thumbnails.transformThumbnailsToJSON)(value.thumbnails),
    source: (0, _sourceEnum.transformSourceEnumToJSON)(value.source),
    width: value.width,
    height: value.height,
    background_color: value.backgroundColor && (0, _colorData.transformColorDataToJSON)(value.backgroundColor),
    density_scale: value.densityScale,
    links: value.links.map(_link.transformLinkToJSON),
    grid: value.grid && (0, _grid.transformGridToJSON)(value.grid),
    layers: value.layers.map(_layer.transformLayerToJSON),
    assets: value.assets.map(_asset.transformAssetToJSON),
    created: value.created
  };
};

exports.transformScreenVersionToJSON = transformScreenVersionToJSON;

var transformJSONToScreenVersion = function transformJSONToScreenVersion(value) {
  return {
    id: value.id,
    creator: value.creator && (0, _user.transformJSONToUser)(value.creator),
    commit: value.commit && (0, _versionCommit.transformJSONToVersionCommit)(value.commit),
    imageUrl: value.image_url,
    thumbnails: value.thumbnails && (0, _thumbnails.transformJSONToThumbnails)(value.thumbnails),
    source: (0, _sourceEnum.transformJSONToSourceEnum)(value.source),
    width: value.width,
    height: value.height,
    backgroundColor: value.background_color && (0, _colorData.transformJSONToColorData)(value.background_color),
    densityScale: value.density_scale,
    links: value.links.map(_link.transformJSONToLink),
    grid: value.grid && (0, _grid.transformJSONToGrid)(value.grid),
    layers: value.layers.map(_layer.transformJSONToLayer),
    assets: value.assets.map(_asset.transformJSONToAsset),
    created: value.created
  };
};
/**
 * 
 * @export
 * @interface ScreenVersion
 */


exports.transformJSONToScreenVersion = transformJSONToScreenVersion;